import React from 'react';
import { createPortal } from 'react-dom';
import $ from 'jquery';
import { PageContext } from '../../context/PageContext';

import { hasSlackFeature } from '../../utilities/featureHelper';
import { getApiRevisionUrl } from '../../utilities/urlHelper';
import { EVENTS } from '../../utilities/CONSTANTS';

const DEFAULT = 'DEFAULT';
const SENDING_NOTIFICATION = 'SENDING_NOTIFICATION';
const NOTIFICATION_SENT = 'NOTIFICATION_SENT';
const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';

class PageNotification extends React.Component {
    static contextType = PageContext;

    constructor(props) {
        super(props);
        const notifyState = DEFAULT;
        const {
            pageAction,
            suggestionUrl,
            questionUrl,
            slackWebhookName,
            slackConversationName,
            showNewPageNotificationButton,
            showPageUpdatedNotificationButton,
        } = window;
        this.state = {
            pageAction,
            suggestionUrl,
            questionUrl,
            slackWebhookName,
            slackConversationName,
            notifyState,
            showNewPageNotificationButton,
            showPageUpdatedNotificationButton,
        };

        window.pageAction = undefined;
        window.suggestionUrl = undefined;
        window.questionUrl = undefined;
        window.slackWebhookName = undefined;
        window.slackConversationName = undefined;
    }

    sendNotification = () => {
        const { notifyState, pageAction: page_action } = this.state;
        if (notifyState !== DEFAULT) return;
        const { page } = this.context;
        if (!page || !page.revision_id) return;
        this.setState({ notifyState: SENDING_NOTIFICATION });
        const url = getApiRevisionUrl(page.revision_id);
        const type = 'PUT';
        $.ajax({ url, type, data: { notify: true, page_action } })
            .done(() => {
                this.setState({ notifyState: NOTIFICATION_SENT });
            })
            .fail(error => {
                this.setState({ notifyState: NOTIFICATION_ERROR });
            });
    };

    getNotifyButtonText = () => {
        const { notifyState, slackWebhookName, slackConversationName } = this.state;
        if (!slackConversationName && !slackWebhookName) {
            return null;
        }

        if (notifyState === SENDING_NOTIFICATION) {
            return 'Sending notification...';
        } if (notifyState === NOTIFICATION_SENT) {
            return slackConversationName
                ? `Notification sent to ${slackConversationName}`
                : `Notification sent to ${slackWebhookName}`;
        } if (notifyState === NOTIFICATION_ERROR) {
            return 'Error while sending; try clicking Share below and contact us if the error continues';
        }

        return slackConversationName
            ? `Notify ${slackConversationName}`
            : `Notify ${slackWebhookName}`;
    };

    getNotifyButtonClass = () => {
        const { notifyState } = this.state;
        if (notifyState == DEFAULT) {
            return 'message-btn';
        }
        return 'italic';
    };

    clickShare = () => window.dispatchEvent(new Event(EVENTS.SHOW_SHARE_MODAL));

    render() {
        const {
            pageAction, suggestionUrl, questionUrl,
            slackConversationName, slackWebhookName,
            notifyState, showNewPageNotificationButton,
            showPageUpdatedNotificationButton,
        } = this.state;
        if (!pageAction) return null;
        const showButton = notifyState == DEFAULT;
        let notificationText = `Page ${pageAction}`;
        notificationText += !suggestionUrl ? '' : ' and request closed';
        notificationText += !questionUrl ? '' : ' and question answered';
        const notificationButtonText = this.getNotifyButtonText();
        const notificationButtonClass = this.getNotifyButtonClass();
        let showNotificationButton = false;
        if (pageAction === 'created' && showNewPageNotificationButton) {
            showNotificationButton = true;
        } else if (pageAction === 'updated' && showPageUpdatedNotificationButton) {
            showNotificationButton = true;
        }
        return (
            <div className="success-message">
                <div className="message-text">{notificationText}</div>
                { suggestionUrl && pageAction === 'created'
                    && <a className="message-btn sm-show" href={suggestionUrl}>View page request</a>}
                { questionUrl && pageAction === 'created'
                    && <a className="message-btn sm-show" href={questionUrl}>View question</a>}
                {showNotificationButton
                    && (
                        <>
                            { showButton && (slackConversationName || slackWebhookName
                                ? (hasSlackFeature()
                                && (
                                    <span className={`${notificationButtonClass} ml1 sm-show`} onClick={this.sendNotification}>
                                        {notificationButtonText}
                                    </span>
                                ))
                                : (hasSlackFeature()
                                && (
                                    <span className="message-btn sm-show" onClick={this.clickShare}>
                                        Share page
                                    </span>
                                )
                                )
                            )}
                            { !showButton && <span className="italic ml1 sm-show">{notificationButtonText}</span> }
                        </>
                    )}
                <button className="close-message" type="button">&times;</button>
            </div>
        );
    }
}

export default PageNotification;
